// Offline JSON handling functionality
import { getAssetFromDB, IMAGE_STORE_NAME } from './indexedDB';

// Function to fetch JSON with offline support
function fetchJSONWithOfflineSupport(jsonPath) {
    return new Promise((resolve, reject) => {
        // Normalize path - remove leading ../ and ensure it starts with /
        let normalizedPath = jsonPath.replace(/^(\.\.\/)+/, '');
        if (!normalizedPath.startsWith('/') && !normalizedPath.startsWith('data:') && !normalizedPath.startsWith('blob:')) {
            normalizedPath = '/' + normalizedPath;
        }
        
        // First try to get from IndexedDB
        getAssetFromDB(IMAGE_STORE_NAME, normalizedPath)
            .then(jsonBlob => {
                if (jsonBlob) {
                    // console.log('JSON found in IndexedDB:', normalizedPath);
                    return jsonBlob.text();
                } else {
                    // If not in IndexedDB, fetch from network
                    // console.log('JSON not in IndexedDB, fetching from network:', normalizedPath);
                    return fetch(jsonPath).then(response => {
                        if (!response.ok) {
                            throw new Error('Network response was not ok');
                        }
                        return response.text();
                    });
                }
            })
            .then(jsonText => {
                try {
                    const jsonData = JSON.parse(jsonText);
                    resolve(jsonData);
                } catch (e) {
                    console.error('Error parsing JSON:', e);
                    reject(e);
                }
            })
            .catch(error => {
                console.error('Error fetching JSON with offline support:', error);
                // Last resort: try direct fetch
                fetch(jsonPath)
                    .then(response => {
                        if (!response.ok) {
                            throw new Error('Network response was not ok');
                        }
                        return response.json();
                    })
                    .then(jsonData => resolve(jsonData))
                    .catch(finalError => reject(finalError));
            });
    });
}

export {
    fetchJSONWithOfflineSupport
};